<button
    #button
    (click)="scrollToTop()"
    matTooltip="Scroll to top"
    [matTooltipShowDelay]="1000"
    [matTooltipHideDelay]="2000">
    <mat-icon [svgIcon]="'chevron_up'" aria-hidden></mat-icon>
    TOP
</button>
